import React, { useMemo, useState } from 'react';
import { ArrowLeft, ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import beitHaoleh1 from './images/projects/beit-haoleh-1.webp';
import beitHaoleh2 from './images/projects/beit-haoleh-2.webp';
import beitHaoleh3 from './images/projects/beit-haoleh-3.webp';
import haamal1 from './images/projects/Labor 11 Ashdod_EXT_01_DL.jpg';
import haamal2 from './images/projects/Labor 11 Ashdod_EXT_02_DL.jpg';
import haamal3 from './images/projects/Labor 11 Ashdod_EXT_03_SS.jpg';
import haamal4 from './images/projects/Labor 11 Ashdod_EXT_04_DL.jpg';
import haamal5 from './images/projects/Labor 11 Ashdod_EXT_05_PTM.jpg';
import kaplinski from './images/projects/kaplinski36rishonlezion.jpeg';
import hativat1 from './images/projects/hativat-hanegev-1.webp';
import hativat2 from './images/projects/hativat-hanegev-2.webp';

const projects = [
  { name: 'חטיבת הנגב 22, אשדוד', images: [hativat1, hativat2] },
  { name: 'העמל 11, אשדוד', images: [haamal1, haamal2, haamal3, haamal4, haamal5] },
  { name: 'בית העולה, רובע י״ג, אשדוד', images: [beitHaoleh1, beitHaoleh2, beitHaoleh3] },
  { name: 'קפלינסקי 36, ראשון לציון', images: [kaplinski] }
];

function WorksCarousel() {
  const [projectIndex, setProjectIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);
  const activeProject = projects[projectIndex];
  const activeImage = activeProject.images[imageIndex];
  const imageLabel = useMemo(
    () => `${activeProject.name} — תמונה ${imageIndex + 1} מתוך ${activeProject.images.length}`,
    [activeProject, imageIndex]
  );

  const chooseProject = (index) => {
    setProjectIndex(index);
    setImageIndex(0);
  };

  const moveImage = (direction) => {
    const count = activeProject.images.length;
    setImageIndex((current) => (current + direction + count) % count);
  };

  return (
    <section id="projects" className="section projects-section" aria-labelledby="projects-title">
      <div className="content-width">
        <header className="projects-heading">
          <div><p className="eyebrow">פרויקטים נבחרים</p><h2 id="projects-title">העבודה שלנו, בתכנון ובשטח</h2></div>
          <p>מבחר תמונות מן הפרויקטים שהחברה תכננה וליוותה.</p>
        </header>

        <div className="project-showcase">
          <div className="project-stage">
            <img src={activeImage} alt={imageLabel} loading="lazy" decoding="async" />
            <div className="project-caption" aria-live="polite">
              <span>פרויקט נבחר</span><strong>{activeProject.name}</strong><small>{imageIndex + 1} / {activeProject.images.length}</small>
            </div>
            {activeProject.images.length > 1 && (
              <div className="project-arrows" aria-label="מעבר בין תמונות הפרויקט">
                <button type="button" onClick={() => moveImage(-1)} aria-label="תמונה קודמת"><ChevronRight aria-hidden="true" /></button>
                <button type="button" onClick={() => moveImage(1)} aria-label="תמונה הבאה"><ChevronLeft aria-hidden="true" /></button>
              </div>
            )}
          </div>

          <div className="project-selector" aria-label="בחירת פרויקט">
            {projects.map((project, index) => (
              <button
                key={project.name}
                className={projectIndex === index ? 'is-active' : ''}
                type="button"
                onClick={() => chooseProject(index)}
                aria-pressed={projectIndex === index}
              >
                <span>0{index + 1}</span>
                <div><strong>{project.name}</strong><small>פרויקט נבחר</small></div>
                <ArrowLeft aria-hidden="true" />
              </button>
            ))}
          </div>
        </div>

        {activeProject.images.length > 1 && (
          <div className="project-thumbnails" aria-label="תמונות נוספות בפרויקט">
            {activeProject.images.map((image, index) => (
              <button
                key={image}
                type="button"
                className={imageIndex === index ? 'is-active' : ''}
                onClick={() => setImageIndex(index)}
                aria-label={`הצגת תמונה ${index + 1} של ${activeProject.name}`}
                aria-pressed={imageIndex === index}
              ><img src={image} alt="" loading="lazy" decoding="async" /></button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default WorksCarousel;
